import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonUrlBasedService } from '../../services/common.url-based.service';
import {
  faArrowRight,
  faClipboard,
  faPenSquare,
  faUserCircle,
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'mec-how-to-join',
  imports: [CommonModule, TranslateModule, FontAwesomeModule],
  templateUrl: './how-to-join.component.html',
  styleUrls: ['./how-to-join.component.scss'],
})
export class HowToJoinComponent {
  iconArrowRight = faArrowRight;
  iconCreateAccount = faClipboard;
  iconStart = faPenSquare;
  iconSubscription = faUserCircle;

  constructor(public _commonService: CommonUrlBasedService) {}

  public goToPage(path: string): void {
    this._commonService.navigate([path]);
  }
}
